<template>
  <a-modal
    title="审核要货单"
    :visible="visible"
    :confirm-loading="loading"
    @ok="handleSubmit"
    @cancel="handleCancel"
    width="900px"
  >
    <a-form-model :model="form" :label-col="{ span: 4 }" :wrapper-col="{ span: 18 }">
      <a-form-model-item label="审核结果">
        <a-radio-group v-model="form.approved">
          <a-radio :value="true">通过</a-radio>
          <a-radio :value="false">驳回</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="审核意见">
        <a-textarea v-model="form.remark" placeholder="请输入审核意见" :rows="3" />
      </a-form-model-item>
    </a-form-model>

    <a-divider>待审核商品</a-divider>

    <a-table
      rowKey="id"
      size="small"
      :columns="columns"
      :data-source="items"
      :row-selection="rowSelection"
      :pagination="false"
    >
      <span slot="itemStatus" slot-scope="text">
        <a-tag :color="getItemStatusColor(text)">{{ getItemStatusText(text) }}</a-tag>
      </span>
    </a-table>

    <div style="margin-top: 12px; text-align: right; color: #666;">
      已选择 <span style="color: #1890ff; font-weight: 600;">{{ selectedRowKeys.length }}</span> 个商品
    </div>
  </a-modal>
</template>

<script>
import { approvePurchaseOrder } from '@/api/retail/purchase'

// 要货明细行状态：0待审核 1已审核 2已发货 3已取消 4已收货 5审核驳回
const ITEM_STATUS_PENDING_AUDIT = 0

export default {
  name: 'ApproveModal',
  data() {
    return {
      visible: false,
      loading: false,
      orderId: null,
      items: [],
      selectedRowKeys: [],
      form: {
        approved: true,
        remark: ''
      }
    }
  },
  computed: {
    columns() {
      return [
        { title: '商品名称', dataIndex: 'goodsName', width: 200, align: 'center' },
        { title: 'SKU名称', dataIndex: 'skuName', width: 150, align: 'center' },
        { title: '要货数量', dataIndex: 'applyCount', width: 100, align: 'center' },
        { title: '当前状态', dataIndex: 'itemStatus', width: 100, align: 'center', scopedSlots: { customRender: 'itemStatus' } }
      ]
    },
    // 只有待审核的商品可以勾选
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: this.handleSelectionChange,
        getCheckboxProps: record => ({
          disabled: record.itemStatus !== ITEM_STATUS_PENDING_AUDIT
        })
      }
    }
  },
  methods: {
    // 勾选状态变化
    handleSelectionChange(keys) {
      this.selectedRowKeys = keys
    },
    getItemStatusText(status) {
      const map = { 0: '待审核', 1: '已审核', 2: '已发货', 3: '已取消', 4: '已收货', 5: '审核驳回' }
      return map[status] || '-'
    },
    getItemStatusColor(status) {
      const map = { 0: 'orange', 1: 'blue', 2: 'cyan', 3: 'red', 4: 'green', 5: 'purple' }
      return map[status] || 'default'
    },
    /**
     * 打开审核弹窗
     * @param orderData 要货单详情（含 items）
     */
    open(orderData) {
      this.orderId = orderData.id
      // 只列出待审核的商品
      this.items = (orderData.items || []).filter(item => item.itemStatus === ITEM_STATUS_PENDING_AUDIT)
      this.selectedRowKeys = this.items.map(item => item.id)
      this.form.approved = true
      this.form.remark = ''
      this.visible = true
    },
    handleSubmit() {
      if (this.selectedRowKeys.length === 0) {
        this.$message.warning('请选择要审核的商品')
        return
      }
      this.loading = true
      approvePurchaseOrder({
        orderId: this.orderId,
        approved: this.form.approved,
        remark: this.form.remark,
        itemIds: this.selectedRowKeys.join(',')
      }).then(() => {
        this.$message.success('审核成功')
        this.visible = false
        this.$emit('ok')
      }).finally(() => {
        this.loading = false
      })
    },
    handleCancel() {
      this.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
</style>
